import { IPrePpWlForm, PrePpWlDescriptionOfDevelopmentDevelopmentTypes, PrePpWlNonResidentialChangeOfUseTypes } from "@shared/prePublicPortalWestLindsay/contracts/IPrePpWlForm";

export const InitialFormState: IPrePpWlForm = {
    // Applicant Details
    applicantTitle: {
        value: "",
        errorMsg: "",
    },
    applicantFirstName: {
        value: "",
        errorMsg: "",
    },
    applicantSurname: {
        value: "",
        errorMsg: "",
    },
    applicantPhoneNumber: {
        value: "",
        errorMsg: "",
    },
    applicantEmail: {
        value: "",
        errorMsg: "",
    },
    applicantCompany: {
        value: "",
        errorMsg: "",
    },
    applicantPostcode: {
        value: "",
        errorMsg: "",
    },
    applicantAddress: {
        value: "",
        errorMsg: "",
    },
    applicantAddressLine1: {
        value: "",
        errorMsg: "",
    },
    applicantAddressLine2: {
        value: "",
        errorMsg: "",
    },
    applicantAddressLine3: {
        value: "",
        errorMsg: "",
    },
    applicantUprn: {
        value: "",
        errorMsg: "",
    },
    applicantEasting: {
        value: "",
        errorMsg: "",
    },
    applicantNorthing: {
        value: "",
        errorMsg: "",
    },
    applicantPostTown: {
        value: "",
        errorMsg: "",
    },
    // Agent details
    agentTitle: {
        value: "",
        errorMsg: "",
    },
    agentFirstName: {
        value: "",
        errorMsg: "",
    },
    agentSurname: {
        value: "",
        errorMsg: "",
    },
    agentPhoneNumber: {
        value: "",
        errorMsg: "",
    },
    agentEmail: {
        value: "",
        errorMsg: "",
    },
    agentCompany: {
        value: "",
        errorMsg: "",
    },
    agentPostcode: {
        value: "",
        errorMsg: "",
    },
    agentAddress: {
        value: "",
        errorMsg: "",
    },
    agentAddressLine1: {
        value: "",
        errorMsg: "",
    },
    agentAddressLine2: {
        value: "",
        errorMsg: "",
    },
    agentAddressLine3: {
        value: "",
        errorMsg: "",
    },
    agentUprn: {
        value: "",
        errorMsg: "",
    },
    agentEasting: {
        value: "",
        errorMsg: "",
    },
    agentNorthing: {
        value: "",
        errorMsg: "",
    },
    agentPostTown: {
        value: "",
        errorMsg: "",
    },
    // Description of development

    typeOfDevelopment: {
        value: "" as typeof PrePpWlDescriptionOfDevelopmentDevelopmentTypes[keyof typeof PrePpWlDescriptionOfDevelopmentDevelopmentTypes],
        errorMsg: "",
    },
    developmentScale: {
        value: "",
        errorMsg: "",
    },
    alterationWidth: {
        value: "",
        errorMsg: "",
    },
    alterationLength: {
        value: "",
        errorMsg: "",
    },
    alterationHeightToEaves: {
        value: "",
        errorMsg: "",
    },
    alterationHeight: {
        value: "",
        errorMsg: "",
    },
    otherAlterationOrExtensionSpecified: {
        value: "",
        errorMsg: "",
    },
    // 2) New Dwellings
    totalNumberOfUnitsProposed: {
        value: "",
        errorMsg: "",
    },
    typeOfNewBuild: {
        value: "",
        errorMsg: "",
    },
    additionalGrossFloorSpace: {
        value: "",
        errorMsg: "",
    },
    additionalFullTimeEmployees: {
        value: "",
        errorMsg: "",
    },
    additionalPartTimeEmployees: {
        value: "",
        errorMsg: "",
    },
    estimatedNumberOfVehicularTrips: {
        value: "",
        errorMsg: "",
    },
    nonResidentialChangeOfUse: {
        value: "" as typeof PrePpWlNonResidentialChangeOfUseTypes[keyof typeof PrePpWlNonResidentialChangeOfUseTypes],
        errorMsg: "",
    },
    alterationsDescription: {
        value: "",
        errorMsg: "",
    },
    otherDevelopmentDescription: {
        value: "",
        errorMsg: "",
    },

    //Site Details
    currentUseOfTheSite: {
        value: "",
        errorMsg: "",
    },
    proposalAffectsAnyTrees: {
        value: "",
        errorMsg: "",
    },
    siteLocationIsSameAsApplicant: {
        value: false,
        errorMsg: "",
    },
    siteLocationAddress: {
        value: "",
        errorMsg: "",
    },
    siteLocationAddressLine1: {
        value: "",
        errorMsg: "",
    },
    siteLocationAddressLine2: {
        value: "",
        errorMsg: "",
    },
    siteLocationAddressLine3: {
        value: "",
        errorMsg: "",
    },
    siteLocationUprn: {
        value: "",
        errorMsg: "",
    },
    siteLocationEasting: {
        value: "",
        errorMsg: "",
    },
    siteLocationNorthing: {
        value: "",
        errorMsg: "",
    },
    siteLocationPostTown: {
        value: "",
        errorMsg: "",
    },
    siteLocationPostcode: {
        value: "",
        errorMsg: "",
    },

    // Stage
    enquiryStage: {
        value: "",
        errorMsg: "",
    },

    // Additional Information
    hardCopySiteLocationPlansWillBeProvided: {
        value: false,
        errorMsg: "",
    },
    blockPlanProvided: {
        value: false,
        errorMsg: "",
    },
    existingDetailsProvided: {
        value: false,
        errorMsg: "",
    },
    proposedDetailsProvided: {
        value: false,
        errorMsg: "",
    },
    photographsProvided: {
        value: false,
        errorMsg: "",
    },
    designStatementProvided: {
        value: false,
        errorMsg: "",
    },
    hardCopyOptionalDocumentsWillBeProvided: {
        value: false,
        errorMsg: "",
    },
    otherInformation: {
        value: "",
        errorMsg: "",
    },
    siteLocationDocuments: {
        value: [],
        errorMsg: "",
    },
    optionalDocuments: {
        value: [],
        errorMsg: "",
    },

    // Fees
    feeAmount: {
        value: "",
        errorMsg: "",
    },
    isCustomFee: {
        value: false,
        errorMsg: "",
    },
    feeMessage: {
        value: "",
        errorMsg: "",
    },
};
